import Moment from './_Moment';

export default class EditForm_Wash extends Moment {
  constructor(props, context) {
    super(props, context, 'wash');
  }
}
